import {ILangdict, Langdict} from './langdict';

export class IAcademicTerm {
  id: string;
  description: ILangdict;
}

export class AcademicTerm extends  IAcademicTerm {
  constructor(obj: IAcademicTerm) {
    super();
    this.id = obj.id;
    this.description = new Langdict(obj.description);
  }
}
